import './money-input.scss';

import { InputNumber, type InputNumberProps } from 'antd';
import classNames from 'classnames';

import { formatPrice } from '@/shared/services/formatters';

interface IProps extends Omit<
  InputNumberProps<number>,
  'value' | 'onChange' | 'formatter' | 'parser' | 'precision' | 'controls'
> {
  value?: number | null;
  onChange: (value: number | null) => void;
}

/** Цифры из ввода; пусто — пустая строка, чтобы поле осталось без значения. */
const parseDigits = (value?: string): number =>
  value?.replace(/\D/g, '') as unknown as number;

/**
 * Сумма в тенге целым числом: разряды через пробел (`1 500 000`), только цифры,
 * пустое поле — `null`, а не 0, чтобы обязательность проверялась честно.
 */
const MoneyInput: React.FC<IProps> = ({
  value,
  onChange,
  className,
  ...props
}) => (
  <InputNumber<number>
    inputMode="numeric"
    min={0}
    suffix="тг."
    {...props}
    className={classNames('money-input', className)}
    value={value}
    precision={0}
    controls={false}
    formatter={(next) => (next === undefined ? '' : formatPrice(next))}
    parser={parseDigits}
    onChange={(next) => onChange(next ?? null)}
  />
);

export default MoneyInput;
